"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ManualBreakSuccess = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _hover = require("../../hooks/hover");
var _styles = require("@material-ui/core/styles");
var _constants = require("../../utils/constants");
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _AccessTime = _interopRequireDefault(require("@material-ui/icons/AccessTime"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _CircularLoader = _interopRequireDefault(require("../CircularLoader"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _Button = _interopRequireDefault(require("../Button"));
var _Textarea = _interopRequireDefault(require("./Textarea"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ManualBreakSetup = function ManualBreakSetup(_ref) {
  var onClose = _ref.onClose,
    isLoading = _ref.isLoading,
    messageMaxLength = _ref.messageMaxLength,
    onRemoveRecentMessage = _ref.onRemoveRecentMessage,
    recentMessages = _ref.recentMessages,
    onSubmit = _ref.onSubmit;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useHover = (0, _hover.useHover)(),
    hovered = _useHover.hovered,
    targetProps = _useHover.targetProps;
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    message = _useState2[0],
    setMessage = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    autoReply = _useState4[0],
    setAutoReply = _useState4[1];
  var _useTheme = (0, _styles.useTheme)(),
    palette = _useTheme.palette;
  var isExeedLimit = message.length >= _constants.AUTO_REPLY_MESSAGE_MAX_LENGTH;
  function handleOnCheck(next) {
    setAutoReply(next);

    // True - populate the default message
    // False - reset message to empty
    setMessage(next ? t('inboxBreak.manual.setup.defaultMessage') : '');
  }
  function handleOnClickRecentmessage(recentMessage) {
    setMessage(recentMessage);
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-6xl text-gray-medium leading-loose"
  }, /*#__PURE__*/_react["default"].createElement(_AccessTime["default"], {
    fontSize: "inherit"
  })), /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-xl text-dark font-bold leading-relaxed"
  }, t('inboxBreak.manual.setup.title')), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-gray-medium"
  }, t('inboxBreak.manual.setup.description')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-12"
  }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
    className: "!mr-0",
    control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      size: "small",
      iconsize: "small",
      name: "autoReply",
      checked: autoReply,
      outerHovered: hovered,
      onChange: handleOnCheck
    }),
    label: /*#__PURE__*/_react["default"].createElement("p", targetProps, t('inboxBreak.autoReply.hint'))
  }), autoReply && /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative"
  }, /*#__PURE__*/_react["default"].createElement(_Textarea["default"], {
    autoFocus: true,
    value: message,
    maxlength: messageMaxLength,
    onChange: function onChange(e) {
      return setMessage(e.target.value);
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full bg-app absolute right-0 text-right",
    style: _objectSpread({
      bottom: '-15px'
    }, palette.type === _constants.themeMode.LIGHT ? {} : {
      boxShadow: 'none',
      backgroundColor: palette.secondary.main
    })
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-xs p-3",
    style: {
      color: isExeedLimit ? 'red' : ''
    }
  }, "".concat(message.length, "/").concat(_constants.AUTO_REPLY_MESSAGE_MAX_LENGTH)))), !!recentMessages.length && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-left text-xs mt-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-gray-medium"
  }, "Recents:"), /*#__PURE__*/_react["default"].createElement("div", null, recentMessages.map(function (_ref2) {
    var id = _ref2.id,
      content = _ref2.content;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: id,
      className: "py-1 flex items-center justify-between"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-primary cursor-pointer truncate mr-2",
      onClick: function onClick() {
        return handleOnClickRecentmessage(content);
      }
    }, content), /*#__PURE__*/_react["default"].createElement("button", {
      className: "text-light hover:text-medium",
      onClick: function onClick() {
        return onRemoveRecentMessage(id);
      }
    }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
      fontSize: "small"
    })));
  })))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex w-full mt-6"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "secondary",
    onClick: onClose,
    disabled: isLoading,
    className: "flex-1 mr-2"
  }, t('button.nevermind')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disabled: isLoading,
    className: "flex-1 ml-2",
    onClick: function onClick() {
      return onSubmit({
        enableAutoReply: autoReply,
        replyMessage: message
      });
    }
  }, isLoading ? /*#__PURE__*/_react["default"].createElement(_CircularLoader["default"], {
    size: 24,
    color: "inherit"
  }) : t('button.startBreak'))));
};
var ManualBreakSuccess = exports.ManualBreakSuccess = function ManualBreakSuccess(_ref3) {
  var endAt = _ref3.endAt,
    onClose = _ref3.onClose,
    timezone = _ref3.timezone,
    isLoading = _ref3.isLoading,
    onEndBreak = _ref3.onEndBreak;
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  var description = (0, _react.useMemo)(function () {
    if (endAt) {
      var currTimezone = _momentTimezone["default"].tz.guess();
      return t('inboxBreak.success.withEndTime', {
        endAt: [_momentTimezone["default"].unix(endAt).format('h:mma'), timezone && timezone !== currTimezone ? _momentTimezone["default"].tz(timezone).format('z') : null].filter(Boolean).join(' ')
      });
    } else {
      return t('inboxBreak.success.withoutEndTime');
    }
  }, [endAt, timezone]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-6xl text-gray-medium leading-loose"
  }, /*#__PURE__*/_react["default"].createElement(_AccessTime["default"], {
    fontSize: "inherit"
  })), /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-xl text-dark font-bold leading-relaxed"
  }, t('inboxBreak.title')), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-gray-medium"
  }, description), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex w-full mt-8"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "secondary",
    className: "w-40 flex-1 mr-2",
    onClick: onClose
  }, t('button.goToInbox')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disabled: isLoading,
    className: "w-40 flex-1 ml-2",
    onClick: onEndBreak
  }, isLoading ? /*#__PURE__*/_react["default"].createElement(_CircularLoader["default"], {
    size: 24,
    color: "inherit"
  }) : t('button.endBreak'))));
};
var _default = exports["default"] = ManualBreakSetup;
//# sourceMappingURL=ManualBreakSetup.js.map